import {
    Component
}
from '@angular/core';
import {
    NavController, NavParams
}
from 'ionic-angular';
import {
    Favoriteprovider
}
from '../../providers/favoriteprovider';
/**
 * Generated class for the Product page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@
Component({
    selector: 'page-product'
    , templateUrl: 'product.html'
, })
export class ProductPage {
    item: any;
    public favoriteItems = [];
    isFavorite: boolean = false;
    constructor(public navCtrl: NavController, public navParams: NavParams, public favoriteProvider: Favoriteprovider) {
        this.item = navParams.get('item');
    }
    ionViewDidLoad() {
        console.log('ionViewDidLoad Product');
    }
    ionViewWillEnter() {
        console.log('Enter product detail');
        this.alreadyFavorite();
    }

    //Check of reeds toegevoegd aan favorieten
    alreadyFavorite(){
            this.favoriteProvider.getFavorites().then((favorites) => {
                if (favorites) {
                    this.favoriteItems = JSON.parse(favorites);
                    
                    for (var i = 0; i < this.favoriteItems.length; i++) {
                        if (this.favoriteItems[i].beaconmajor == this.item.beaconmajor) {
                            this.isFavorite = true;
                            console.log('Dit item is reeds een favoriet');
                        }
                    }
                }
            });
    }
    
    favoriteItem() {
        this.favoriteItems.push(this.item);
        this.favoriteProvider.save(this.favoriteItems);
        console.log('Toegevoegd aan favorieten');
        this.isFavorite = true;
    }
}


// WEBPACK FOOTER //
// ./src/pages/product/product.ts